import { Dispatch } from 'redux'

import * as actions from './actions'

import { useThunkActions } from 'redux/actions/useThunkActions'

import {
  addVisit,
  getDashboardExamples,
  copy
} from 'redux/api/DashboardExamples'
import * as UserEvents from 'redux/api/internal/UserEvents'

import { Action, Context } from 'types/GlobalUserEvents'
import { toggleSnackbarOpen } from '../Snackbar'
import { SnackbarMessage } from 'types/GlobalSnackbar'

import * as dashboardActions from '../Dashboards/actions'

function tryGetAllDashboardExamples() {
  return (dispatch: Dispatch) => {
    dispatch(actions.getAll())

    getDashboardExamples()
      .then((response) => {
        dispatch(actions.getAllSuccess(response.data.data))
      })
      .catch(() => {
        dispatch(actions.getAllFailed())
      })
  }
}

function tryAddDashboardExampleVisit(dashboardId: string) {
  return () => {
    addVisit({ data: { dashboard_id: dashboardId } }).catch(() => {
      // do nothing
    })
  }
}

function tryCopyDashboardExample(
  dashboardId: string,
  title: string,
  callback: (id: string | null, err?: boolean) => void
) {
  return (dispatch: Dispatch) => {
    dispatch(dashboardActions.create())

    copy(dashboardId, { data: { title } })
      .then((response) => {
        UserEvents.log({
          action: Action.DASHBOARD_CREATED,
          context: Context.FROM_EXPLORE,
          dashboard_id: response.data.data.dashboard.id,
          dashboard_group_id: response.data.data.group.id
        })

        dispatch(dashboardActions.createSuccess(response.data.data))

        dispatch(toggleSnackbarOpen(SnackbarMessage.DashboardCreated))

        callback(response.data.data.group.dashboards[0].id)
      })
      .catch(() => {
        dispatch(dashboardActions.createFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.DashboardCreatedFailed))

        callback(null, true)
      })
  }
}

export const useDashboardExampleActions = () => {
  return {
    tryCopyDashboardExample: useThunkActions(tryCopyDashboardExample),
    tryAddDashboardExampleVisit: useThunkActions(tryAddDashboardExampleVisit),
    tryGetAllDashboardExamples: useThunkActions(tryGetAllDashboardExamples)
  }
}
